module.exports = __webpack_public_path__ + "static/ibarra-commencement-0fe4483d80354477753a04f6446915ae.jpg";